import z from 'zod';
export const JsonValueSchema = z.json();
export const JsonObjectSchema = z.record(z.string(), JsonValueSchema.optional());
export function createExpressionOrValueSchema(schema) {
    return z.union([
        z.object({
            value: schema,
            isExpression: z.literal(false),
        }),
        z.object({
            value: z.string(),
            isExpression: z.literal(true),
        }),
    ]);
}
export const ExpressionOrJsonValueSchema = createExpressionOrValueSchema(JsonValueSchema.optional());
export const ExpressionableOptionsObjectSchema = z.record(z.string(), ExpressionOrJsonValueSchema.optional());
export var CompanionFieldVariablesSupport;
(function (CompanionFieldVariablesSupport) {
    /** Uses the internal parser, and supports all the features */
    CompanionFieldVariablesSupport["InternalParser"] = "internalParser";
    /** Old style parsing, with limited local variables */
    CompanionFieldVariablesSupport["LocalVariables"] = "local";
    /** Old style parsing, with no local variables */
    CompanionFieldVariablesSupport["Basic"] = "basic";
})(CompanionFieldVariablesSupport || (CompanionFieldVariablesSupport = {}));
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isExpressionOrValue(input) {
    return !!input && typeof input === 'object' && 'isExpression' in input && typeof input.isExpression === 'boolean';
}
export function optionsObjectToExpressionOptions(options, allowExpressions = true) {
    const res = {};
    for (const [key, val] of Object.entries(options)) {
        res[key] = allowExpressions && isExpressionOrValue(val) ? val : { value: val, isExpression: false };
    }
    return res;
}
export function convertExpressionOptionsWithoutParsing(options) {
    const res = {};
    for (const [key, val] of Object.entries(options)) {
        res[key] = val?.value;
    }
    return res;
}
export function exprVal(value) {
    return { value: value, isExpression: false };
}
export function exprExpr(value) {
    return { value: value, isExpression: true };
}
//# sourceMappingURL=Options.js.map